<template>
	<div class="file_step">
		<!-- <div class="info_list">
			<div class="first_title">填写密码</div>
			<div class="item">
				<input type="text" placeholder="6 - 16位密码，区分大小写" v-model="pwd">
			</div>
			<div class="item">
				<input type="text" placeholder="确认密码" v-model="ensurePwd">
			</div>
		</div> -->
		
		<div class="info_list">
			<div class="first_title">Your information</div>
			<div class="last_title">fields marked with a * are required</div>
			<!-- <div class="item">
				<input type="text" placeholder="First name*" v-model="userInfo.first_name">
			</div>
			<div class="item">
				<input type="text" placeholder="Last name*" v-model="userInfo.last_name">
			</div> -->
			<div class="item">
				<input type="text" placeholder="Address line 1*" v-model="userInfo.address_line_one">
			</div>
			<div class="item">
				<input type="text" placeholder="Address line 2*" v-model="userInfo.address_line_two">
			</div>
			<div class="item">
				<input type="text" placeholder="Town*" v-model="userInfo.town">
			</div>
			<div class="item">
				<input type="text" placeholder="PostCode*" v-model="userInfo.psot_code">
			</div>
			<div class="item">
				<input type="text" placeholder="Email*" v-model="userInfo.email">
			</div>
			<!-- <div class="item">
				<input type="text" placeholder="Mobile*" v-model="userInfo.mobile">
			</div> -->
		</div>
		<div class="permission flex align-center" @click="is_privacy = !is_privacy">
			<img v-if="is_privacy" class="select" src="../../assets/images/icon/select_active.png" alt="">
			<img v-else class="select" src="../../assets/images/icon/select.png" alt="">
			<div class="title">Please accept the <span @click.stop="toTerm">Terms and Conditions</span></div>
			
		</div>
		
		<div class="next_btn" @click='toNext'>Next</div>
	</div>
</template>

<script>
	export default{
		props:{
			userInfo:{
				type:Object
			}
		},
		data(){
			return{
				firstName:'',
				lastName:'',
				address1:'',
				address2:'',
				town:'',
				postCode:'',
				email:'',
				mobile:'',
				is_privacy:false,
				is_contact:false	
			}
		},
		methods:{
			toTerm(){
				this.$emit('toTerm')
			},
			toNext(){
				var params = {
					first_name:this.userInfo.first_name,
					last_name:this.userInfo.last_name,
					address_line_one:this.userInfo.address_line_one,
					address_line_two:this.userInfo.address_line_two,
					town:this.userInfo.town,
					psot_code:this.userInfo.psot_code,
					mobile:this.userInfo.mobile,
					email:this.userInfo.email
				}
				if(!this.is_privacy){
					this.$message({
						showClose:true,
						duration:0,
						message:'"Agree to Terms and Conditions" is Required'
					})
					return
				}
				// if(!this.userInfo.first_name){
				// 	this.$message('First Name is Required');
				// 	return
				// }
				// if(!this.userInfo.last_name){
				// 	this.$message('Last name is Required');
				// 	return
				// }
				if(!this.userInfo.address_line_one){
					this.$message({
						showClose:true,
						duration:0,
						message:'Address line 1 is Required'
					})
					
					return
				}
				if(!this.userInfo.address_line_two){
					this.$message({
						showClose:true,
						duration:0,
						message:'Address line 2 is Required'
					})
					return
				}
				if(!this.userInfo.town){
					this.$message({
						showClose:true,
						duration:0,
						message:'Town is Required'
					})
					return
				}
				if(!this.userInfo.psot_code){
					this.$message({
						showClose:true,
						duration:0,
						message:'PostCode is Required'
					})
					return
				}
				// if(!this.userInfo.mobile){
				// 	this.$message('Mobile is Required');
				// 	return
				// }
				if(!this.userInfo.email){
					this.$message('Email is Required');
					return
				}
				
				this.$api.post('user/profile',params,res=>{
					if(res.code == 1){
						this.$store.commit("changeUserInfo",params)
						this.$emit('toNext',{type:1})
					}else{
						this.$message(res.msg)
					}
				})
				
				
			}
		}
	}
</script>

<style lang="scss">
	.file_step{
		.info_list{
			width: 800px;
			margin: 0 auto;
			margin-bottom: 60px;
			.first_title{
				font-size: 20px;
				font-family: Source Han Sans CN;
				font-weight: 500;
				color: #282E30;
			}
			.item{
				width: 100%;
				height: 80px;
				background: #F7F2EB;
				border: 1px solid #282E30;
				border-radius: 10px;
				margin-top: 30px;
				padding-left: 30px;
				font-size: 20px;
				font-family: Source Han Sans CN;
				font-weight: 500;
				color: #999999;
				line-height: 80px;
				input{
					width: 100%;
					height: 100%;
				}
			}
		}
		.permission{
			width: 800px;
			margin: 0 auto;
			margin-bottom: 50px;
			cursor: pointer;
			.title{
				font-size: 20px;
				font-family: Source Han Sans CN;
				font-weight: 500;
				color: #282E30;
				span{
					color: #5C707A;
				}
			}
			.select{
				width: 16px;
				height: 16px;
				border: 1px solid #282E30;
				border-radius: 50%;
				margin-right: 5px;
			}
		}
		.last_title{
			text-align: center;
			margin-top: 20px;
		}
		.next_btn{
			width: 182px;
			height: 57px;
			background: #5C707A;
			border-radius: 29px;
			line-height: 57px;
			text-align: center;
			margin: 58px auto;
			font-size: 20px;
			font-family: Source Han Sans CN;
			font-weight: 400;
			color: #F7F2EB;
			cursor: pointer;
		}
	}
</style>